module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0082.jpg?v=012d3c85";